let ASSIGNMENTS_SELECTOR_TABS = [{
  options: {
    tabName: 'courses',
    title: 'ASSIGNMENTS_SELECTOR_COURSES',
    uri: '/courses',
    dataSet: 'entitler',
    searchLabel : 'course name or course id or course code'
  },
  columns: [{
    name: 'assigned',
    label: 'ASSIGNED',
    truncated: true,
    type: 'table-grid-checkbox-cell',
    isSortable: true,
    sortAlias: '!isAssigned,name',
    headerCheckboxable: true
  }, {
    name: 'name',
    label: 'NAME',
    type: 'table-grid-text-cell',
    isSortable: true
  }, {
    name: 'courseId',
    label: 'ID',
    type: 'table-grid-text-cell',
    isSortable: true
  }, {
    name: 'courseCode',
    label: 'CODE',
    type: 'table-grid-text-cell',
    isSortable: true,
    hide: true, 
    hideIfEmpty: true
  }, {
    name: 'school',
    label: 'ASSIGNED_SCHOOLS',
    type: 'table-grid-dropdown-cell',
    isSortable: false
  }],
  courses: {
    selectedPropertyCurrentTab: 'selectedCourses'
  }
}, {
  options: {
    tabName: 'classes',
    title: 'ASSIGNMENTS_SELECTOR_CLASSES',
    uri: '/classes',
    dataSet: 'entitler',
    searchLabel : 'class, class id, school, or teacher last or first name'
  },
  columns: [{
    name: 'assigned',
    label: 'ASSIGNED',
    truncated: true,
    type: 'table-grid-checkbox-cell',
    isSortable: true,
    sortAlias: '!isAssigned,name',
    headerCheckboxable: true
  }, {
    name: 'name',
    label: 'CLASS_NAME_LABEL',
    type: 'table-grid-text-cell',
    isSortable: true
  }, {
    name: 'classId',
    label: 'CLASS_ID_LABEL',
    type: 'table-grid-text-cell',
    isSortable: true
  }, {
    name: 'schoolName',
    label: 'CLASS_SCHOOL_LABEL',
    type: 'table-grid-text-cell',
    isSortable: true
  }, {
    name: 'familyName',
    label: 'TEACHER',
    type: 'table-grid-text-cell',
    isSortable: true,
    virtualAttribute: (row) => {
      const name = row.familyName ? `${row.familyName}, ${row.givenName}` : '';
      return name;
    }
  }],
  classes: {
    selectedPropertyCurrentTab: 'selectedClasses'
  }
},{
  options: {
    tabName: 'users',
    title: 'ASSIGNMENTS_SELECTOR_PEOPLE',
    uri: '/users',
    active: true,
    dataSet: 'entitler',
    searchLabel : 'last or first name, user id, or role'
  },
  columns: [{
    name: 'assigned',
    label: 'ASSIGNED',
    truncated: true,
    type: 'table-grid-checkbox-cell',
    isSortable: true,
    sortAlias: '!isAssigned,name',
    headerCheckboxable: true
  }, {
    name: 'familyName',
    label: 'NAME',
    type: 'table-grid-text-cell',
    isSortable: true,
    virtualAttribute: (row) => {
      const name = row.name ? `${row.name}, ${row.givenName}` : '';
      return name;
    }
  }, {
    name: 'userId',
    label: 'USER_ID_LABEL',
    type: 'table-grid-text-cell',
    isSortable: true
  }, {
    name: 'role',
    label: 'USER_ROLE_LABEL',
    type: 'table-grid-text-cell',
    formatFilter: 'uppercase',
    isSortable: true
  }],
  users: {
    selectedPropertyCurrentTab: 'selectedUsers'
  }
}];
export
default ASSIGNMENTS_SELECTOR_TABS;



// WEBPACK FOOTER //
// ./app/models/assignmentsTabs.js